export interface C0RenderMeasurement {
  stableFrameMs: number;
  domNodes: number;
  measuredAt: string;
}

export function captureInitialRender(root: HTMLElement, startedAt: number): void {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      const measurement: C0RenderMeasurement = Object.freeze({
        stableFrameMs: Number((performance.now() - startedAt).toFixed(1)),
        domNodes: root.querySelectorAll("*").length,
        measuredAt: new Date().toISOString(),
      });
      Object.defineProperty(window, "__AEC_C0_RENDER__", {
        configurable: true,
        value: measurement,
      });
    });
  });
}
